import { Question } from "../../types/Question";
import { Tag } from "../../types/Tag";
import TagInput from "../generic/TagInput";
import { useGetTagsQuery } from "../../../features/api/tagSlice";

import React, { useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

interface QuestionFormProps {
    question: Question;
    onQuestionChange: (question: Question) => void;
    onSubmit: () => Promise<boolean>;
    onCancel: () => void;
}

const QuestionForm: React.FC<QuestionFormProps> = ({ question, onQuestionChange, onSubmit, onCancel }) => {
    const [titleError, setTitleError] = useState<string>("");
    const [bodyError, setBodyError] = useState<string>("");
    const [tagError, setTagError] = useState<string>("");
    const tags = question.tags;
    const setTags = (tags: Tag[]) => onQuestionChange({ ...question, tags });
    const { data: allTags } = useGetTagsQuery();

    function onTitleChange(title: string) {
        onQuestionChange({ ...question, title });
        setTitleError("");
    }

    function onBodyChange(body: string) {
        onQuestionChange({ ...question, body });
        setBodyError("");
    }

    async function handleFormSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        let error: boolean = false;
        if (!question.title) {
            error = true;
            setTitleError("Title cannot be empty");
        }
        if (question.title.length > 180) {
            error = true;
            setTitleError("Title cannot be longer than 180 characters");
        }
        if (!question.body) {
            error = true;
            setBodyError("Body cannot be empty");
        }
        if (tags.length > 5) {
            error = true;
            setTagError("Cannot have more than 5 tags");
        }
        if (error) {
            console.log("error");
            return;
        }
        const success = await onSubmit();
        if (!success) {
            setTitleError("Unable to post question");
        }
    }

    return (
        <Box
            component="form"
            noValidate
            autoComplete="off"
            onSubmit={handleFormSubmit}
            onReset={onCancel}
            sx={{ display: "grid" }}
        >
            <TextField
                id="question-title"
                name="question-title"
                label="Question Title"
                error={!!titleError}
                helperText={titleError}
                value={question.title}
                onChange={(event) => onTitleChange(event.target.value)}
                fullWidth
                margin="normal"
                sx={{
                    ".MuiInputBase-input": { fontSize: "large" },
                }}
            />

            <TextField
                id="question-body"
                name="question-body"
                label="Question Body"
                multiline
                error={!!bodyError}
                helperText={bodyError}
                value={question.body}
                onChange={(event) => onBodyChange(event.target.value)}
                fullWidth
                margin="normal"
                minRows={5}
                sx={{
                    ".MuiInputBase-input": { fontSize: "large" },
                }}
            />

            <TagInput
                tags={tags}
                onTagsChange={setTags}
                tagError={tagError}
                setTagError={setTagError}
                allTags={allTags}
            />

            <Stack direction="row" spacing={2}>
                <Button type="reset">Cancel</Button>
                <Button type="submit">Post</Button>
            </Stack>
        </Box>
    );
};

export default QuestionForm;
